<template>
    <div class="order-history">
        <h2 class="order-history__title">{{ $t("OrderHistory.order_history") }}</h2>
        <OrderAccordion id="order-accordion" :content="orderHistory" />
    </div>
</template>

<script>
    import OrderAccordion from 'components/user/orderinfo/OrderAccordion'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            OrderAccordion
        },
        computed: {
            ...mapGetters({
                orderHistory: 'User/getOrderHistory'
            })
        },
        created () {
            this.$store.dispatch('User/loadOrderHistory')
        }

    }
</script>

<style lang="scss" scoped>
    .order-history {
        background: $white;
        border: 1px solid $quill_gray;
        padding: 20px;

        &__title {
            margin: 0 0 20px;
        }
    }
</style>
